<template>
  <transition name="fade">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    >
      <div
        class="bg-white rounded-lg w-full mx-4 p-6 relative text-black"
        style="width: 95%!important; max-width: 860px"
      >
        <button
          class="absolute text-4xl top-0 right-2 text-gray-500 hover:text-gray-700"
          @click="$emit('close')"
        >
          &times;
        </button>

        <!-- Slot content goes here -->
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
